var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"outlined":_vm.outlined,"label":_vm.label,"autocomplete":"off","type":"email","dense":"","rules":[ ..._vm.rules, _vm.validationIsEmailValid ]},model:{value:(_vm.mailData),callback:function ($$v) {_vm.mailData=$$v},expression:"mailData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }